export const emailReceipt = {
    method: 'POST',
    paths: [
        '/api/orgs/:orgId/locations/:locationId/orders/:orderId/emailReceipt',
        '/api/orgs/:orgId/locations/:locationId/orderByClientId/:clientOrderId/emailReceipt',
    ],
    fields: {
        email: {
            type: 'email',
            required: true,
        },
        guestConsentedToMarketing: {
            type: 'bool',
        },
    },
};
//# sourceMappingURL=orders_email_receipt.js.map